import { apiAuth, apiResponseType } from ".";

export const getMyEmployeeProfile = (): apiResponseType =>
  apiAuth.get("employee-profile/me");

export const updateMyEmployeeProfile = (data) =>
  apiAuth.postForm("employee-profile/me/update", data) as apiResponseType;
